import Rails from "@rails/ujs"

const OVERLAY_ID = 'js-loading-overlay';

export function showOverlay() {
  const overlay = document.getElementById(OVERLAY_ID);
  if (overlay) {
    overlay.classList.remove('is-hidden');
    document.documentElement.style.overflow = 'hidden';
  }
}

export function hideOverlay() {
  const overlay = document.getElementById(OVERLAY_ID);
  if (overlay) {
    overlay.classList.add('is-hidden');
    document.documentElement.style.overflow = '';
  }
}

// 内容のある最初の .{errormClass} 要素へスムーズスクロール
export function scrollToFirstError(errormClass) {
  const errors = Array.from(document.querySelectorAll('.' + errormClass))
    .filter(el => el.innerHTML.trim() !== '');
  if (errors.length > 0) {
    errors[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

// ---- YAS-31: iOS WebKit 空body送信対策の共通部品 ---------------------------
// 詳細は .steering/20260814-ios-empty-body-rollout/design.md
//
// iOS 26系 WebKit では、写真ライブラリ由来の File を含む multipart POST が、エラーにならず
// 空body（Content-Length: 0）で送信されることがある。サーバ側では params.require が
// ActionController::ParameterMissing を上げ、ユーザーには何も表示されないまま失敗していた。

// 検証AJAX用の FormData を構築する。
// 検証時は実ファイルを送らず、ファイル名・種別を保持した1バイトの代理ファイルに差し替える
// （サーバ側の存在・拡張子・サイズ下限チェックは代理ファイルでも同一に機能する）。
// 実ファイルは本登録のネイティブ submit でのみ送信する。
export function buildValidationFormData(form) {
  const formData = new FormData(form);
  for (const [key, value] of Array.from(formData.entries())) {
    if (value instanceof File && value.name) {
      formData.set(key, new File(["0"], value.name, { type: value.type }));
    }
  }
  return formData;
}

// 空body由来（サーバが 400 + code:"empty_body" を返した）かどうか。
// 通信断やタイムアウトで再送すると実ファイルの送信を繰り返して悪化するため、
// 自動リトライはこの条件のときだけに限定する。
export function isEmptyBodyError(response, xhr) {
  return xhr != null && xhr.status === 400 && response != null && response.code === "empty_body";
}

// 検証AJAX（validateAll）の送信を1か所に集約する。
//  - 空body由来の失敗のみ 500ms 後に1回だけ再送する
//  - JSON でない応答（セッション切れの 302 → HTML 等）は success ではなく失敗として扱う
//    ＝「押しても何も起きない」無言失敗を無くす
// onSuccess(response) / onFailure(response) は必須。onFailure でオーバーレイ解除・ボタン復帰・
// エラー表示を行うこと（呼び出し側の UI 事情はここに持ち込まない）。
export function postValidation({ url, buildFormData, onSuccess, onFailure }, attempt = 1) {
  Rails.ajax({
    url: url,
    type: "POST",
    dataType: 'json',
    data: buildFormData(),
    success: (response) => {
      if (response == null || typeof response !== "object") {
        onFailure(null);
        return;
      }
      onSuccess(response);
    },
    error: (response, statusText, xhr) => {
      if (attempt < 2 && isEmptyBodyError(response, xhr)) {
        setTimeout(() => postValidation({ url, buildFormData, onSuccess, onFailure }, attempt + 1), 500);
        return;
      }
      onFailure(response);
    }
  });
}

// 失敗時に表示する文言。サーバが返した error があればそれを、無ければ汎用の通信エラー文言を使う。
export function failureMessage(response, fallback) {
  return (response != null && response.error != null) ? response.error : (fallback || "");
}
